export default __webpack_public_path__ + "static/media/logo_final.effe56b9.png";